/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Google_FailedInputs */

const cs_auth_google_failed = /** @type {(inputs: Auth_Google_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení přes Google se nezdařilo`)
};

const en_auth_google_failed = /** @type {(inputs: Auth_Google_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google sign-in failed`)
};

/**
* | output |
* | --- |
* | "Google sign-in failed" |
*
* @param {Auth_Google_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_google_failed = /** @type {((inputs?: Auth_Google_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Google_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_google_failed(inputs)
	return cs_auth_google_failed(inputs)
});